import React from 'react';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedComponent } from '../../../redux/selectedComponentSlice';
import ErrorBoundary from '../Error/ErrorBoundary';
import _ from 'lodash';
import EditorInputsHeader from './EditorInputsHeader';
import EditorInputsBody from './EditorInputsBody';
import { setHoverElement } from '../../../redux/hoverElementSlice';

function calcX(xPos, boxW) {
	const xPosToNum = parseFloat(xPos);
	const boxWToNum = parseFloat(boxW);
	return window.innerWidth < xPosToNum + boxWToNum ? xPosToNum - boxWToNum + 'px' : xPos;
}

function calcY(yPos) {
	//a caixa vai ter no máximo ~450px
	const yPosToNum = parseFloat(yPos);
	return window.innerHeight < yPosToNum + 450 ? window.innerHeight - 525 + 'px' : yPos;
}

const EditorInputsWM = () => {
	const dispatch = useDispatch();
	const boxW = '500px';
	// const dispatch = useDispatch()
	// const selectedPageValue = useSelector(selectedPage)
	const { props: selectedComponentPropsValue, xPos, yPos } = useSelector(selectedComponent);
	//dragging puro, sem lib
	const [isDragging, setIsDragging] = React.useState(false);
	const editorRef = React.useRef(null);

	React.useEffect(() => {
		if (!selectedComponentPropsValue) {
			dispatch(setHoverElement({ componentId: null, componentName: null }));
		}
	}, [selectedComponentPropsValue]);

	if (!selectedComponentPropsValue) return null;

	return (
		<ErrorBoundary isToast={true}>
			<Box
				transition={'none'}
				ref={editorRef}
				borderRadius={'6px'}
				boxShadow="xl"
				m={1}
				zIndex={9999}
				w={boxW}
				bg={'white'}
				position={'fixed'}
				left={calcX(xPos, boxW)}
				top={calcY(yPos)}
			>
				<EditorInputsHeader {...{ editorRef, setIsDragging, isDragging }} />
				<EditorInputsBody />
			</Box>
		</ErrorBoundary>
	);
};

const EditorInputs = React.memo(EditorInputsWM);
export default EditorInputs;
